(() => {
  const init = (root) => {
    if (!root || root.dataset.referralEnhanced) return;
    root.dataset.referralEnhanced = 'true';
    const text = (selector, value) => {
      const node = root.querySelector(selector);
      if (node && node.textContent.trim() !== value) node.textContent = value;
    };
    const attribute = (node, name, value) => {
      if (node && node.getAttribute(name) !== value) node.setAttribute(name, value);
    };
    const enhance = () => {
      text('#sj_rlp_guest_heading', 'Get your referral link');
      text('#sj_rlp_guest_subheading', 'Enter your name and email to get your personal link. Then share it with a friend who’s new to YAGA.');
      text('.sj_rlp_user_heading', 'Your link. Their first YAGA order.');
      text('.sj_rlp_user_subheading', 'Share your link to give a new customer 30% off their first order. You earn $25 in credit after that first order is completed.');
      attribute(root.querySelector('#sj_rlp_guest_submit_button'), 'value', 'Get my referral link');
      const name = root.querySelector('#sj_rlp_guest_name_input');
      const email = root.querySelector('#sj_rlp_guest_email_input');
      attribute(name, 'aria-label', 'Your name');
      attribute(name, 'autocomplete', 'name');
      attribute(email, 'aria-label', 'Your email address');
      attribute(email, 'autocomplete', 'email');
      const terms = root.querySelector('.sj_rlp_guest_form_main > .sj_rlp_guest_page_text');
      if (terms) {
        const link = terms.querySelector('a');
        if (link) {
          attribute(link, 'href', '/policies/terms-of-service');
          attribute(link, 'rel', 'noopener');
          const prefix = [...terms.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.includes('By clicking'));
          if (prefix && prefix.textContent !== 'By getting your referral link, you accept the ') prefix.textContent = 'By getting your referral link, you accept the ';
        }
      }
    };
    enhance();
    const observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true });
    root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  };
  document.querySelectorAll('[data-yaga-referral]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-yaga-referral]').forEach(init);
  });
})();
